import { ReactElement } from 'react';

import {
  InlineAlert,
  Typography,
} from '@beeline/design-system-react/extracted-styles';

import styles from './styles.module.scss';

interface ErrorElementProps {
  message: string | boolean;
  email: string;
}

export function ErrorElement({
  message,
  email,
}: ErrorElementProps): ReactElement {
  return (
    <InlineAlert className={styles.alert} type='error'>
      <Typography className={styles.errorText} variant='body2'>
        Не удалось запустить модуль. Обратитесь в техническую поддержку:{' '}
        <b>{email}</b>
      </Typography>

      <Typography className={styles.errorFragment} variant='body3'>
        <b>Ошибка:</b> {message}
      </Typography>
    </InlineAlert>
  );
}
